// tslint:disable-next-line:no-var-requires
__webpack_public_path__ = require('../../config').PUBLIC_PATH;
